const TOOLS_MENU_TITLES = {
  CLOUD_MANAGEMENT: '__CLOUD_MANAGEMENT',
  DIVIDER: '__DIVIDER',
  FAVORITES: '__FAVORITES',
  ORDER_TRACKING: 'Track an order',
}

export default TOOLS_MENU_TITLES
